<template>
  <div
    v-if="order"
    class="mx-auto p-6 mt-6 border border-gray-300 rounded-lg shadow-md"
    style="width: 800px"
  >
    <h2 class="text-xl font-bold mb-8">Quittung #{{ order.id }}</h2>

    <div class="flex justify-between items-center mb-6">
      <div>
        <h3 class="text-md font-semibold mb-2">Verkäufer</h3>
        <div>{{ order.event.organizer.company_name }}</div>
        <div>{{ order.event.organizer.street }}</div>
        <div>{{ order.event.organizer.zip_code }} {{ order.event.organizer.city }}</div>
      </div>
      <span class="text-gray-500 text-sm">Datum: {{ order.created_at.local | longDate }} Uhr</span>
    </div>

    <div class="mb-6">
      <h3 class="text-md font-semibold mb-2">Veranstaltung</h3>
      <p class="font-medium">{{ order.event.title }}</p>
      <p class="text-gray-600">{{ order.event.start_date | shortDate }} Uhr</p>
      <p class="text-gray-600">{{ order.event.venue.name }}, {{ order.event.venue.city }}</p>
    </div>

    <div class="mb-6">
      <h3 class="text-md font-semibold mb-2">Tickets</h3>
      <table class="w-full border-collapse">
        <thead>
          <tr>
            <th class="text-sm border-b-2 border-gray-200 p-2 text-left">#</th>
            <th class="text-sm border-b-2 border-gray-200 p-2 text-left">Kategorie</th>
            <th class="text-sm border-b-2 border-gray-200 p-2 text-left">Typ</th>
            <th class="text-sm border-b-2 border-gray-200 p-2 text-left">Preis</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="ticket in order.tickets"
            :key="ticket.id"
            :class="{ 'line-through': ticket.refunded }"
          >
            <td class="border-b border-gray-200 p-2">{{ ticket.code }}</td>
            <td class="border-b border-gray-200 p-2">{{ ticket.type.category.title }}</td>
            <td class="border-b border-gray-200 p-2">{{ ticket.type.title }}</td>
            <td class="border-b border-gray-200 p-2">{{ ticket.price | price }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="3" class="text-right font-semibold p-2">Total für {{ count }} Tickets:</td>
            <td class="font-semibold p-2">{{ total | price }}</td>
          </tr>
        </tfoot>
      </table>

      <div class="text-sm text-gray-600 mt-4">
        Diese Quittung berechtigt nicht zum Vorsteuerabzug.
      </div>
    </div>

    <button
      @click="printReceipt"
      class="mt-4 px-4 py-2 bg-green-600 text-white font-semibold rounded hover:bg-green-700"
    >
      Drucken
    </button>
  </div>
</template>

<script>
import orderClient from '@/api/merchant/orders';
import dayjs from 'dayjs';
import _sumBy from 'lodash/sumBy';

export default {
  methods: {
    printReceipt() {
      window.print();
    },
  },

  data() {
    return {
      order: {},
      loading: true,
    };
  },

  filters: {
    shortDate(value) {
      return dayjs(value).format('DD MMM YYYY HH:mm');
    },
    longDate(value) {
      return dayjs(value).format('dddd, DD MMMM YYYY HH:mm');
    },
    price(value) {
      var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      });

      return formatter.format(value / 100);
    },
  },

  mounted() {
    orderClient.show(this.$route.params.id).then(({ data }) => {
      this.order = data.data;
      this.loading = false;
    });
  },

  computed: {
    total() {
      return _sumBy(this.order.tickets, (ticket) => ticket.price);
    },
  },
};
</script>

<style scoped>
@media print {
  button {
    display: none;
  }
}
</style>